module.exports = __webpack_public_path__ + "unity.de01f3.svg";